import './brokers.scss';

(function ($) {
  'use strict';

  $(document).ready(function () {
    const delegationContainer = document.querySelector('.paragraph_broker_hub');
    if (delegationContainer) {
      const delegationItem = delegationContainer.querySelectorAll('.col-12');

      delegationItem.forEach((val) => {
        if (val.children.length < 1) {
          val.remove();
        }
      });
    }
  });

})(jQuery);
